const initialState = {
    loading: false,
    data: [],
    error: null,
  };
  
  const getTalentRolesReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'FETCH_TALENT_ROLE_REQUEST':
        return { ...state, loading: true, error: null };
      case 'FETCH_TALENT_ROLE_SUCCESS':
        return { ...state, loading: false, data: action.payload, error: null };
      case 'FETCH_TALENT_ROLE_FAILURE':
        return { ...state, loading: false, data: [], error: action.payload };
      case 'FETCH_TALENT_ROLE_COMPLETE':
        return { ...state, loading: false };
      default:
        return state;
    }
  }; 
  
  export default getTalentRolesReducer;